module.exports = __webpack_public_path__ + "img/message-check-circle.b5a3d5e8.svg";